import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { convertUTCtoIST, decodeToken } from "../../functions/authUtils";

const authDataString = localStorage.getItem("authData");
const authData =
  authDataString !== "undefined" && authDataString
    ? JSON.parse(authDataString)
    : undefined;
const userLoginString = Cookies.get("isLoggedIn");
const token = Cookies.get("token");
const userLogin = userLoginString ? JSON.parse(userLoginString) : false;
interface AuthProps {
  authData: PatientDetailsTypes | null;
  openLogoutModal: boolean;
  userLogin: boolean;
  token: string | null;
}
const initialState: AuthProps = {
  authData: authData || null,
  openLogoutModal: false,
  userLogin: userLogin || false,
  token: token || null,
};
const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData: (state, action: PayloadAction<AuthProps["authData"]>) => {
      state.authData = action.payload;
      localStorage.setItem("authData", JSON.stringify(action.payload));
    },
    setAuthToken: (state, action: PayloadAction<AuthProps["token"]>) => {
      state.token = action.payload;
      if (action.payload) {
        const decodedToken = decodeToken(action.payload);
        if (decodedToken && decodedToken.exp) {
          const expTimestamp = decodedToken.exp * 1000;
          const expiryDateUTC = new Date(expTimestamp);
          const expiryDateIST = convertUTCtoIST(expiryDateUTC);
          Cookies.set("token", action.payload, { expires: expiryDateIST });
          Cookies.set("isLoggedIn", "true", { expires: expiryDateIST });
          state.userLogin = true;
        }
      }
    },
    handleLogout: (state) => {
      Cookies.remove("token");
      Cookies.remove("isLoggedIn");
      localStorage.removeItem("authData");
      state.authData = null; 
      state.token = null;
      state.userLogin = false;
      state.openLogoutModal = false;
    },
    handleOpenLogoutModal: (state) => {
      state.openLogoutModal = true;
    },
    handleCloseLogoutModal: (state) => {
      state.openLogoutModal = false;
    },
  },
});

export const {
  handleOpenLogoutModal,
  handleCloseLogoutModal,
  setAuthData,
  setAuthToken,
  handleLogout
} = AuthSlice.actions;
export default AuthSlice;
